import { create } from 'zustand';
import { createSelectors } from './createSelectors';
import { getCompanyInfo, CompanyInfoResponse } from '../apis/companyApi';

interface CompanyState {
  companyInfo: CompanyInfoResponse | null;
  getCompanyInfo: () => Promise<CompanyInfoResponse>;
}

const useCompanyStoreBase = create<CompanyState>((set, get) => ({
  companyInfo: null,
  getCompanyInfo: async () => {
    let companyInfo = get().companyInfo;
    if (!companyInfo) {
      companyInfo = await getCompanyInfo();
      set({ companyInfo });
    }
    return companyInfo;
  },
}));

export const useCompanyStore = createSelectors(useCompanyStoreBase);
